<template>
  <div class="bg-white rounded rounded-lg mensagem p-4">
    <span v-if="icon" class="material-icons" :style="{ color: color }">
      {{ icon }}
    </span>
    <div class="mt-3">
      <div v-if="title" class="title text-primary my-3">{{ title }}</div>
      <div v-if="description" class="description text-secondary my-3">
        {{ description }}
      </div>
    </div>
    <div>
      <Botao
        title="Voltar"
        :link="link"
        nameClass="btn btn-outline-secondary btn-lg btn-block px-5 mt-4"
        >VOLTAR</Botao
      >
    </div>
  </div>
</template>
<script>
import Botao from "@/components/botoes/Botao";

export default {
  name: "Mensagem",
  props: {
    icon: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "#11A04E",
    },
    title: {
      type: String,
      default: "arrow_back_ios",
    },
    description: {
      type: String,
      default: "arrow_back_ios",
    },
    link: {
      type: String,
      default: "#",
    },
  },
  components: {
    Botao,
  },
};
</script>
<style lang="scss" scoped>
.mensagem {
  min-height: 50vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .material-icons {
    font-size: 80px;
  }
  .title {
    font-size: 24px;
    font-weight: bold;
    text-align: center;
  }
  .description {
    max-width: 600px;
    text-align: center;
  }
}
</style>
